export default {
	location: 'الموقع',
	'gps-data': 'بيانات جهاز GPS'
}